import moment from 'moment';

export const blockedNumbersHashMap = (state) => {
  return _.keyBy(_.filter(state.blockedNumbers, (bn) => {
    return !bn.timeLimited || moment(bn.expiration).diff(moment()) > 0;
  }), (blockedNumber) => {
    return blockedNumber.phoneNumber;
  });
};